<div class="migration-onboarding-root" *transloco="let t">
  <app-onboarding>
    <app-epson-logo image></app-epson-logo>
    <app-carousel [nextPageLabel]="t('next-feature')"
                  [previousPageLabel]="t('previous-feature')"
                  [finishLabel]="t('lets-begin')"
                  [anchorText]="t('skip-to-home')"
                  (finish)="goToHome()"
                  [pages]="carouselPages"
                  content></app-carousel>
  </app-onboarding>
</div>
